import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import { createArray } from "utils/surveyHelper";

const SurveyPreviewShimmer = () => {
  return (
    <div className="survey_detail">
      <div className="_card">
        {createArray(1).map((blockName, index) => {
          return (
            <p key={index}>
              <SkeletonLoader type={"text"} height={26} width={150} />
            </p>
          );
        })}
        {createArray(4)?.map((index) => {
          return (
            <div className="survey_card" key={`option-index-${index}`}>
              <h5 className="field_type">
                <SkeletonLoader type={"text"} height={30} width={550} />
              </h5>

              <label className="label">
                <SkeletonLoader type={"text"} height={180} width={300} />
              </label>

              <div className="question_image">
                <SkeletonLoader type={"text"} height={20} count={4.75} width={500} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SurveyPreviewShimmer;
